import { paths } from '@/util/paths';
import {
  tenantHasDocumentsAccess,
  tenantHasFormFillingAccess,
  tenantHasGonogoAccess,
  tenantHasOpportunitiesAccess,
  tenantHasTasksAccess,
} from '@/util/module-access-util';

// The settings menu each role sees, in order: sections of { path, label } (i18n keys). The menu
// lists it, and phones title a settings page with its item's label.
export const settingsMenu = ({ isManager, isAdminTenant, isAdmin }) => {
  const item = (path, label, shown = true) => shown && { path, label };
  const section = (key, title, items) => ({ key, title, items: items.filter(Boolean) });

  return [
    section('general', 'basic-words.general', [
      item(paths.adminUserProfile, 'menu.admin-user-profile'),
      item(paths.adminUserNotifications, 'menu.admin-user-notifications'),
      item(paths.adminUsers, 'menu.admin-users'),
      item(paths.adminTenant, 'menu.admin-tenant'),
    ]),
    isManager &&
      section('manager', 'roles.ROLE_MANAGER', [
        item(paths.adminTenantProfile, 'menu.admin-tenant-profile', tenantHasFormFillingAccess()),
        item(paths.adminInvites, 'menu.admin-invites'),
        item(paths.adminBilling, 'menu.admin-billing'),
        item(paths.adminOpportunitySettings, 'menu.admin-opportunity-settings', tenantHasOpportunitiesAccess()),
        item(paths.adminOpportunityManagement, 'menu.admin-opportunity-statuses', tenantHasOpportunitiesAccess()),
        item(paths.adminOpportunityLabels, 'menu.admin-opportunity-labels', tenantHasOpportunitiesAccess()),
        item(paths.adminSyncProfiles, 'menu.admin-sync-profiles', tenantHasOpportunitiesAccess()),
        item(paths.adminGoNoGo, 'menu.admin-go-nogo', tenantHasGonogoAccess()),
        item(paths.adminEvaluationGrid, 'menu.admin-evaluation-grid', tenantHasDocumentsAccess()),
        item(paths.adminTaskTemplates, 'menu.admin-task-templates', tenantHasTasksAccess()),
      ]),
    // Tenant admin: settings of the current account.
    isAdminTenant &&
      section('admin-tenant', 'roles.ROLE_ADMIN_TENANT', [
        item(paths.adminKeywords, 'menu.admin-keywords'),
        item(paths.adminDocumentKeywords, 'menu.admin-document-keywords', tenantHasDocumentsAccess()),
        item(paths.adminTerminology, 'menu.admin-terminology'),
        item(paths.adminModules, 'menu.admin-modules'),
        item(paths.adminPlatforms, 'menu.admin-platforms'),
      ]),
    // Platform admin: every account, Aloha-wide.
    isAdmin &&
      section('admin', 'roles.ROLE_ADMIN', [
        item(paths.adminTenants, 'menu.admin-tenants'),
        item(paths.adminScraperHealth, 'menu.admin-scraper-health'),
        item(paths.adminPlatformCatalog, 'menu.admin-platform-catalog'),
        item(paths.adminPreProjectsImport, 'menu.admin-pre-projects-import'),
      ]),
  ].filter(Boolean);
};

// The menu item a settings page belongs to (itself, or a page deeper in it).
const sectionOf = (menu, path) =>
  menu.flatMap((section) => section.items).find((item) => path === item.path || path.startsWith(`${item.path}/`));

// The label of the menu item a settings page belongs to (itself, or a page deeper in it).
export const settingsSectionLabel = (menu, path) => {
  const match = sectionOf(menu, path);
  return match ? match.label : null;
};

// For a page deeper in a menu item (a sync profile's fields), the item's page: where its back leads.
export const settingsParentPath = (menu, path) => {
  const match = sectionOf(menu, path);
  return match && match.path !== path ? match.path : null;
};
